define.alias("shared/modifiers/autoresize", "settings/modifiers/autoresize");